import * as React from 'react';
import {connect} from "react-redux";
import {Document} from "../../models/Document";
import {ApplicationState} from "../../store";
import {ColumnData} from '../../models/ColumnData';
import {Tab, TabTypes} from "../Tab";
import {TabsService} from "../TabsService";
import {User} from "../../models/User";
import {actionDeleteDocuments, actionDocumentFetchAll} from "../../store/documents";
import {DocumentList} from "../components/DocumentList";
import {FormatTypes} from "../../core/Formater";
import {Department} from "../../models/Department";
import {useEffect, useState} from "react";
import {actionUserFetchAll} from "../../store/users";
import {actionDepartmentsFetchAll} from "../../store/departments";
import {actionCustomerFetchAll} from "../../store/customers";
import {Customer} from "../../models/Customer";
import {documentsStatusMap} from "../../dms/definitions/BaseDocument";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {Button, FormHelperText, Grid, Paper, TextField, Typography} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {hr} from "date-fns/esm/locale";
import {Utility} from "../../core/Utility";

const FilterByDateRange = (props: any) => {   /* function for adding 2 textfields for date range */

	const maxDate = new Date("2100-01-01")
	const minDate = new Date("1900-01-01")
	const dateOffset = (24*60*60*1000) * 30; //5 days
	const initDateFrom = new Date();
	initDateFrom.setTime(initDateFrom.getTime() - dateOffset);
	const [dateFrom, setDateFrom] = useState<Date>(initDateFrom)
	const [dateTo, setDateTo] = useState<Date>(new Date())

	return <MuiPickersUtilsProvider utils={DateFnsUtils} locale={hr}>
		<div style={{display: 'flex', minWidth: '300px', margin: 0}}>
			<KeyboardDatePicker
				margin="normal"
				id="date-picker-dialog"
				format={Utility.PICKER_DATE_FORMAT}
				value={dateFrom}
				onChange={(date) => {
					setDateFrom(date)
					props.onFilterChanged(props.columnDef.tableData.id, {dateFrom: date, dateTo});
				}}
				onBlur={null}
				onFocus={null}
				InputLabelProps={{
					shrink: true,
				}}
				maxDate={maxDate}
				minDate={minDate}
				style={{flex: 1, margin: 0}}
			/>
			<KeyboardDatePicker
				margin="normal"
				id="date-picker-dialog"
				format={Utility.PICKER_DATE_FORMAT}
				value={dateTo}
				onChange={(date) => {
					setDateTo(date)
					props.onFilterChanged(props.columnDef.tableData.id, {dateFrom, dateTo: date});
				}}
				onBlur={null}
				onFocus={null}
				InputLabelProps={{
					shrink: true,
				}}
				maxDate={maxDate}
				minDate={minDate}
				style={{flex: 1, margin: 0}}
			/>
		</div>
	</MuiPickersUtilsProvider>
};

const FilterByText = (props: any) => {   /* function for adding 2 textfields for date range */

	return <TextField
		// value={'test'}
		onChange={(e) => {
			let value = e.target.value
			props.onFilterChanged(props.columnDef.tableData.id, value);
			console.log(value)
		}}
		margin="normal"
		fullWidth
		style={{margin: 0}}
	/>
};

export interface DocumentsSearchTabProps {
	documents: Document[],
	users: User[],
	departments: Department[]
	customers: Customer[]
	tab: Tab
}

export interface DocumentsSearchTabState {
}

const mapStateToProps = (state: ApplicationState) => {
	return {
		documents: state.documents.list,
		users: state.users.list,
		departments: state.departments.list,
		customers: state.customers.list,
		tab: state.tabs.active
	};
}

const DocumentsSearchTab = (props: DocumentsSearchTabProps) => {

	// const [documents, setDocuments] = useState<Document[]>([])
	// const [users, setUsers] = useState<User[]>([])
	// const [departments, setDepartments] = useState<Department[]>([])
	// const [tab, setTab] = useState<Tab>(null)

	useEffect(() => {
		actionDocumentFetchAll()
		actionUserFetchAll()
		actionDepartmentsFetchAll()
		actionCustomerFetchAll()
	}, [])

	const onOpenClick = (document: Document) => {
		let documentToRelaod = new Document()
		documentToRelaod.id = document.id
		TabsService.createTab(Document.getTitle(document), TabTypes.DOCUMENT_NEW, documentToRelaod)
	}

	const onCopyClick = (document: Document) => {
		TabsService.createTab(document.title, TabTypes.DOCUMENT_NEW, { ...document, id: null })
	}

	const onDeleteClick = (document: Document) => {
		// actionContractDelete(contract);
	}

	const onActionDeleteClick = (documents: Document[]) => {
		actionDeleteDocuments(documents);
	}

	const onNewClick = () => {
		TabsService.createTab('Novi dokument', TabTypes.DOCUMENT_NEW, new Document())
	}

	props.documents.map((document) => {
		if (Array.isArray(document.tags)) document.tags = document.tags.join('  ')
		else document.tags = ''
	})

	const usersMap = props.users.reduce(function(map: any, user: User) {
		map[user.id] = `${user.firstName} ${user.lastName}`;
		return map;
	}, {});

	const sectorsMap = props.departments.reduce(function(map: any, department: Department) {
		map[department.id] = `${department.title}`;
		return map;
	}, {});

	const customersMap = props.customers.reduce(function(map: any, customer: Customer) {
		map[customer.id] = `${customer.vatId}`;
		return map;
	}, {});

	for (let document of props.documents) {
		for (let customer of props.customers) {
			if (document.fields.clientId == customer.id) {
				document.fields.vatId = customer.vatId
			}
		}
	}

	const statusMap:any = documentsStatusMap

	// derive financial status
	for (const document of props.documents) {
		if (document.state == 'approved') {
			document.financialStatus = 'neplaćeno i neproknjiženo'
		}
		else if (document.state == 'not-payed_booked') {
			document.financialStatus = 'neplaćeno'
		} else if (document.state == 'payed_not-booked') {
			document.financialStatus = 'neproknjiženo'
		}
		else {
			document.financialStatus = 'ostalo'
		}
		if (document.fields.selectedForPayment === undefined) {
			document.fields.selectedForPayment = false
		}
	}

	// Delovodni broj, Datum, Broj dokumenta, Klijent, Tip dokumenta, Korisnik, Tagovi
	const columns = [
		new ColumnData('Delovodni broj', "fields", null, 'indexingNumber' ),
		new ColumnData<Document>('Datum', "fields", null, 'indexingDate', FormatTypes.DATE,
			(props) => <FilterByDateRange {...props} />, {
				minWidth: 300
			}, (range: any, rowData: any) => {
				return +range.dateFrom <= +Date.parse(rowData.fields.indexingDate) && +range.dateTo >= +Date.parse(rowData.fields.indexingDate)
			} ),
		new ColumnData<Document>('Datum valute', "fields", null, 'dueDate', FormatTypes.DATE,
			(props) => <FilterByDateRange {...props} />, {
				minWidth: 300
			}, (range: any, rowData: any) => {
				return +range.dateFrom <= +Date.parse(rowData.fields.dueDate) && +range.dateTo >= +Date.parse(rowData.fields.dueDate)
			} ),
		new ColumnData<Document>('Broj dokumenta', "fields", null, 'documentNumber' ),
		//new ColumnData<Document>('PIB partnera', "fields", customersMap, 'clientId' ),
		new ColumnData<Document>('PIB partnera', "fields", customersMap, 'clientId', null,
			(props) => <FilterByText {...props} />, null,
			(term: any, rowData: any) => {
				return rowData.fields.vatId && rowData.fields.vatId.includes(term)
			}),
		new ColumnData<Document>('Sektor', "fields", sectorsMap, 'sectorId' ),
		// new ColumnData<Document>('Naziv', "title" ),
		new ColumnData<Document>('Tip', "type" ),
		new ColumnData<Document>('Status', "state", statusMap ),
		// new ColumnData<Document>('Fin. status', "financialStatus", { 'neplaćeno': 'neplaćeno', 'neproknjiženo': 'neproknjiženo', 'neplaćeno i neproknjiženo': 'neplaćeno i neproknjiženo', 'ostalo': 'ostalo' }),
		new ColumnData<Document>('Fin. status', "financialStatus"),
		new ColumnData<Document>('Selektovan za plaćanje', "fields", { 'true': 'da', 'false': 'ne'}, 'selectedForPayment' ),
		new ColumnData<Document>('Iznos', "fields", null , 'amount' ),
		new ColumnData<Document>('Korisnik', "assignedTo", usersMap),
		new ColumnData<Document>('Tagovi', "tags")
	];

	return (
		<div style={{padding: '10px'}}>
			{/*<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewContract}</Button></div>*/}
			<DocumentList
				columns={columns}
				items={props.documents}
				title={'Dokumenta'}
				onOpenClick={(document: Document) => onOpenClick(document)}
				onCopyClick={(document: Document) => onCopyClick(document)}
				onDeleteClick={(document: Document) => onDeleteClick(document)}
				onActionDeleteClick={(documents: Document[]) => onActionDeleteClick(documents)}
				tab={props.tab}
			/>
		</div>
	);

}

export default connect(mapStateToProps)(DocumentsSearchTab);

